import KendoMenu from './KendoMenu'
import KendoMenuItem from './KendoMenu/KendoMenuItem'
import KendoContextMenu from './KendoContextMenu'
import KendoPanelBar from './KendoPanelBar'
import KendoPanelBarItem from './KendoPanelBar/KendoPanelBarItem'
import KendoTabStrip from './KendoTabStrip'
import KendoSplitter from './KendoSplitter'
import KendoSplitterPane from './KendoSplitter/KendoSplitterPane'
import KendoLayoutInstaller from './kendo-layout-installer'

export { KendoMenu, KendoMenu as Menu, KendoContextMenu, KendoContextMenu as ContextMenu, KendoMenuItem, KendoMenuItem as MenuItem, KendoPanelBar, KendoPanelBar as PanelBar, KendoPanelBarItem, KendoPanelBarItem as PanelBarItem, KendoTabStrip, KendoTabStrip as TabStrip, KendoSplitter, KendoSplitter as Splitter, KendoSplitterPane, KendoSplitterPane as SplitterPane, KendoLayoutInstaller, KendoLayoutInstaller as LayoutInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/index.js